export const MEMBERS_VALIDATION_RULES = {
    memberIdentifier: {
        isRequiredTrim: {
            value: true,
        },
        maxLength: {
            value: 15,
        },
    },
    divisionId: {
        isRequiredTrim: {
            value: true,
        },
    },
    firstName: {
        isRequiredTrim: {
            value: true,
        },
    },
    lastName: {
        isRequiredTrim: {
            value: true,
        },
    },
    phoneNumber: {
        isRequiredTrim: {
            value: false,
        }
    },
    emailAddress: {
        isRequiredTrim: {
            value: false,
        },
        regex: {
            value: {
                pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                customMessageKey: "validation.emailRegex",
            },
        },
    },
    birthdate: {
        isRequiredTrim: {
            value: true,
        },
    },
    socialInsuranceNumber: {
        noSpaces: {
            value: true,
        },
        maxLength: {
            value: 9,
        },
        minLength: {
            value: 9,
        },
    },
    memberGenderType: {
        isRequiredTrim: {
            value: true,
        },
    },
    languageCode: {
        isRequiredTrim: {
            value: true,
        },
    },
    importationDate: {
        isRequiredTrim: {
            value: true,
        },
    },
    address: {
        isRequiredTrim: {
            value: true,
        },
    },
    city: {
        isRequiredTrim: {
            value: true,
        },
    },
    provinceCode: {
        isRequiredTrim: {
            value: true,
        },
    },
    postalCode: {
        isRequiredTrim: {
            value: true,
        },
    },
    countryCode: {
        isRequiredTrim: {
            value: true,
        },
    },
    weeklyHours: {
        regex: {
            value: {
                pattern: /^$|^[([0-9]+((\.)[0-9]+|(,)[0-9]+)*$/i,
                customMessageKey: "validation.float",
            },
        },
    },
    customEmailAddress: {
        regex: {
            value: {
                pattern: /^$|[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,
                customMessageKey: "validation.emailRegex",
            },
        },
    },
    customPhoneNumber: {
        isRequiredTrim: {
            value: false,
        },
    },
    provincialHealthNumber: {
        isRequiredTrim: {
            value: true,
        },
        maxLength: {
            value: 16,
        },
    },
    employeeNumber: {
        maxLength: {
            value: 64,
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/membersValidationRules.js